<ol
  *ngIf="listItemProps$ | async as listItemsProps"
  class="row ms-1 ps-0 w-100"
>
  <flo-node-list-item
    *ngFor="let listItemProps of listItemsProps; trackBy: trackById"
    [props]="listItemProps"
    class="col-12 px-0 py-md-4 py-3 my-1 border-bottom"
  ></flo-node-list-item>
</ol>
